import { graphql } from "gql.tada";

export const PartnershipsHeroById = graphql(`
  query PartnershipsHeroById($locale: String, $preview: Boolean, $id: String!) {
    partnershipsHero(id: $id, preview: $preview, locale: $locale) {
      ...PartnershipsHeroFragment
    }
  }
  fragment PartnershipsHeroFragment on PartnershipsHero {
    title
    description
    ctaText
    previewVideo {
      url
      contentType
    }
    fullVideo {
      url
      contentType
    }
  }
`);
